import { useDispatch } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import RootState from './types'

export type AppDispatch = ThunkDispatch<RootState, void, AnyAction>

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()
